import { render } from "./holidays-table.vue?vue&type=template&id=b0c7081e"
import script from "./holidays-table.vue?vue&type=script&lang=js"
export * from "./holidays-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__